<template>
    <b-row no-gutters class="pt-2">
        <b-col class="d-none d-md-flex">
            <p class="m-0 d-flex align-items-center">
                <span class="text-muted">
                    <slot name="last-checkin" />
                </span>
            </p>
        </b-col>
        <b-col>
            <div class="d-flex justify-content-end align-items-center">
                <div class="mr-3">
                    <slot name="checkin-btn" />
                </div>
                <div>
                    <slot name="dropdown" />
                </div>
            </div>
        </b-col>
    </b-row>
</template>

<script>
export default {
    name: 'ActionsContainer',
}
</script>
